import React from 'react'
import PropTypes from 'prop-types'

import { TextField } from '@material-ui/core'

import helpers from 'helpers'

export default function InputPhone({ onChange, ...rest }) {
  const [value, setValue] = React.useState(rest.value)

  React.useEffect(() => {
    setValue(helpers.people.formatPhone(rest.value))
  }, [rest.value])

  const handleChange = event => {
    const formattedValue = helpers.people.formatPhone(event.target.value)

    onChange({ target: { name: rest.name, value: formattedValue } })
    setValue(formattedValue)
  }

  return <TextField {...rest} value={value} onChange={handleChange} />
}

InputPhone.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
}
